import React from "react";
import Slider from "react-slick";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { person1, person2, person3, person4, person5, person6 } from "../../assets/img";

const winners = [
  { name: "Rahul Sharma", prize: "₹25,00,000", img: person1 },
  { name: "Priya Mishra", prize: "₹10,00,000", img: person2 },
  { name: "Suresh Iyer", prize: "₹5,00,000", img: person3 },
  { name: "Meena Raj", prize: "₹50,000", img: person4 },
  { name: "Karthik Rao", prize: "₹75,000", img: person5 },
  { name: "Anitha Devi", prize: "₹1,00,000", img: person6 },
];

const WinnerGallery = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 3,
    slidesToScroll: 1,
    pauseOnHover: false,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 1 } },
      { breakpoint: 1024, settings: { slidesToShow: 2 } }
    ]
  };

  return (
    <div className="ticket-grid-container1">
      <h2 className="ticket-title">🎟️ Winner Lottery Tickets</h2>

      <Slider {...settings}>
        {winners.map((w, i) => (
          <div key={i} className="ticket-card">
            <div className="ticket-shape">
              <img src={w.img} alt={w.name} className="ticket-img" />

              <h3 className="ticket-name">{w.name}</h3>

              <div className="ticket-prize">
                <CurrencyRupeeIcon />
                <span>{w.prize}</span>
              </div>

              <p className="ticket-id">Ticket No: WIN-{1000 + i}</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default WinnerGallery;
